import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';

const STORAGE_KEY = 'cookie_consent';

export const getCookieConsent = () => {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch (e) {
    return null;
  }
};

const CookieConsent = ({ onDecision }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!getCookieConsent()) {
      setVisible(true);
    }
  }, []);

  const decide = (value) => {
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch (e) {
      // localStorage kullanılamıyorsa (gizli sekme vb.) sessizce yut
    }
    setVisible(false);
    onDecision?.(value);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-20 lg:bottom-4 left-4 right-4 lg:left-auto lg:right-4 lg:max-w-md z-[200]">
      <div className="bg-[#0f1419] text-white rounded-2xl shadow-2xl p-5 border border-gray-800">
        <div className="flex gap-3">
          <Cookie className="text-[#2171b5] flex-shrink-0 mt-0.5" size={22} />
          <div>
            <p className="text-sm text-gray-300 leading-relaxed">
              Sitemiz, ziyaret istatistiklerini ölçmek amacıyla kişisel veri içermeyen anonim bir çerez kullanır.
              Detaylar için{' '}
              <Link to="/gizlilik-politikasi" className="text-[#4a9eea] hover:underline">
                Gizlilik Politikası
              </Link>
              'nı inceleyebilirsiniz.
            </p>
          </div>
        </div>
        <div className="flex gap-3 mt-4">
          <button
            onClick={() => decide('rejected')}
            className="flex-1 px-4 py-2.5 rounded-xl text-sm font-bold bg-transparent border border-gray-600 text-gray-300 hover:bg-gray-800 transition"
          >
            Reddediyorum
          </button>
          <button
            onClick={() => decide('accepted')}
            className="flex-1 px-4 py-2.5 rounded-xl text-sm font-bold bg-[#2171b5] hover:bg-[#1e5a8e] text-white transition"
          >
            Kabul Ediyorum
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
